import { BatchCheckpointsScanner } from '../pages';
import { RouteObject } from 'react-router-dom';

const BatchCheckpointsRoutes: RouteObject[] = [
  {
    path: 'batch-checkpoints',
    children: [
      {
        path: '',
        element: <BatchCheckpointsScanner />,
      },
    ],
  },
];

export default BatchCheckpointsRoutes;
